<template>
  <div
    id="data-management"
    class="page page-data-management"
  >
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <h4>Module Configuration</h4>
      <div class="actions--wrapper">
        <router-link
          v-if="currentUserPermission === permissionTypes.admin"
          id="globalPermissionsButton"
          :to="{name: 'globalPermissions'}"
          class="btn btn-secondary"
        >
          <font-awesome-icon :icon="['fas', 'key']" />
          Global Permissions
        </router-link>
        <b-button
          v-if="canCreate"
          id="createNewModule"
          variant="secondary"
          @click="showEditModuleModal"
        >
          <font-awesome-icon :icon="['fas', 'plus-square']" />
          Create New Module
        </b-button>
      </div>
    </div>

    <content-spinner
      v-if="!moduleConfiguration"
      :show="!moduleConfiguration"
    />
    <div
      v-else
      id="pageContent"
      class="page-content p-4"
    >
      <generic
        entity-type="module"
        :model="systemModules"
        :is-d-n-d-activated="false"
      />
      <generic
        entity-type="module"
        :model="MDMModules"
        :is-d-n-d-activated="true"
      />
    </div>
    <folder-modal v-if="folderModal.show" />
    <module-modal v-if="moduleModal.show" />
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import TableCard from '../../components/TableCard';
import FolderModal from '../folder/modals/FolderModal';
import ModuleModal from '../module/modals/ModuleModal';
import {UNSET_FOLDER_LIST} from '@/store/modules/data-management/mutation-types';
import FolderCard from '../folder/components/FolderCard';
import ModuleCard from '../module/components/ModuleCard';
import NewTableItem from '@/modules/DataManagement/views/module/components/NewTableItem.vue';
import FolderHeader from '@/modules/DataManagement/views/module/components/FolderHeader.vue';
import NoContent from '@/core/components/NoContent.vue';
import GridDNDComponent from '@/core/components/DNDCardsGrid.vue';
import Generic from '@/core/components/Generic.vue';

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('dataManagement');
const {mapState: userMapState} = createNamespacedHelpers('user');
const {
  mapState: sidebarMapState,
  mapActions: sidebarMapActions,
} = createNamespacedHelpers('sidebar');

export default {
  name: 'DataManagement',
  components: {
    Generic,
    GridDNDComponent,
    NoContent,
    FolderHeader,
    NewTableItem,
    ModuleCard,
    FolderCard,
    FolderModal,
    TableCard,
    ContentSpinner,
    ModuleModal,
  },
  data() {
    return {
      groups: [],
      systemModules: null,
      MDMModules: null,
    };
  },
  watch: {
    moduleConfiguration: {
      handler(val) {
        if (!val) return;
        this.systemModules = val[0];
        this.MDMModules = val[1];
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      permissionTypes: state => state.permissionTypes,
      folderModal: state => state.folderModal,
      moduleModal: state => state.moduleModal,
    }),
    ...userMapState({
      currentUserPermission: state => state.currentUserAdpPermission.data.role,
    }),
    ...sidebarMapState({
      moduleConfiguration: state => state.moduleConfiguration,
      isLoading: state => state.isLoading,
    }),
    canCreate() {
      return [
        this.permissionTypes.admin,
        this.permissionTypes.edit,
      ].includes(this.currentUserPermission);
    },
  },
  methods: {
    ...mapActions(['showModuleModal', 'deleteModule']),
    ...mapMutations([UNSET_FOLDER_LIST]),
    ...sidebarMapActions(['prepareModuleConfigurationData']),
    showEditModuleModal() {
      this.showModuleModal();
    },
  },
  destroyed() {
    this[UNSET_FOLDER_LIST]();
  },
};
</script>

<style scoped>


.actions--wrapper {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  gap: 5px;
}

@media (min-width: 1000px) {
  .actions--wrapper {
    flex-direction: row;
  }
}
</style>
